import { Component } from '@theme/component';
import { morph } from '@theme/morph';
import { StandardEvents } from '@shopify/events';

/**
 * Keeps the pre-order notice in step with the picked variant.
 *
 * Picking a size makes Horizon fetch the section again but morph only the
 * variant picker; everyone else reads the fresh HTML from the event's promise
 * (the pattern of `product-inventory.js`). Whether the notice shows is decided
 * in Liquid, so this copies the new render of the same block and never
 * repeats the rule.
 *
 * @extends {Component}
 */
class MmPreorderNotice extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.closest('.shopify-section, dialog')?.addEventListener(StandardEvents.productSelect, this.#onProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.closest('.shopify-section, dialog')?.removeEventListener(StandardEvents.productSelect, this.#onProductSelect);
  }

  /** @param {Event & { promise?: Promise<any> }} event */
  #onProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      ?.then(({ detail }) => {
        if (!detail?.html) return;

        const { html, newProduct } = detail;
        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        const next = html.querySelector(`mm-preorder-notice[data-block-id="${this.dataset.blockId}"]`);

        // A product without the tag renders no notice at all.
        if (!next) {
          this.hidden = true;
          this.replaceChildren();
          return;
        }

        this.hidden = next.hasAttribute('hidden');
        morph(this, next, { childrenOnly: true });
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[mm-preorder-notice] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('mm-preorder-notice')) {
  customElements.define('mm-preorder-notice', MmPreorderNotice);
}
